import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { LeadResponse } from "@/types/api";
import { useCreateLead, useUpdateLead } from "@/hooks/useLeads";

interface LeadModalProps {
  isOpen: boolean;
  onClose: () => void;
  lead: LeadResponse | null;
}

const LeadModal = ({ isOpen, onClose, lead }: LeadModalProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [waId, setWaId] = useState("");

  const createLead = useCreateLead();
  const updateLead = useUpdateLead();

  useEffect(() => {
    setName(lead?.name || "");
    setEmail(lead?.email || "");
    setWaId(lead?.waId || "");
  }, [lead]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (lead) {
      // Editar lead existente
      await updateLead.mutateAsync({
        id: lead.id,
        data: { name, email, waId },
      });
    } else {
      // Criar novo lead
      await createLead.mutateAsync({ name, email, waId });
    }
    onClose();
  };

  const isLoading = createLead.isPending || updateLead.isPending;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{lead ? "Editar Lead" : "Novo Lead"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            placeholder="Nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <Input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
          />
          <Input
            placeholder="WhatsApp"
            value={waId}
            onChange={(e) => setWaId(e.target.value)}
          />
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancelar
            </Button>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? "Salvando..." : "Salvar"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default LeadModal;
